import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles';
import { WbGrid, WbSkeleton } from '@workbench/react';

const useStyles = makeStyles()((theme: Theme) => ({
    mainContainer: {
        padding: theme.spacing(4),
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(4),
    },
    imageSkeleton: {
        width: '100%',
        height: 750,
        borderRadius: theme.shape.borderRadius,
    },
    headline: {
        width: '60%',
        height: theme.spacing(3),
    },
    buttonRow: {
        display: 'flex',
        gap: theme.spacing(2),
        justifyContent: 'space-between',
    },
    buttonSkeleton: {
        width: 200,
        height: 100,
        borderRadius: theme.shape.borderRadius,
    },
}));

export default function MainSkeleton() {
    const { classes } = useStyles();

    return (
        <WbGrid className={classes.mainContainer}>
            <WbSkeleton className={classes.imageSkeleton} />
            <WbSkeleton className={classes.headline} />
            <div className={classes.buttonRow}>
                <WbSkeleton className={classes.buttonSkeleton} />
                <WbSkeleton className={classes.buttonSkeleton} />
                <WbSkeleton className={classes.buttonSkeleton} />
                <WbSkeleton className={classes.buttonSkeleton} />
                <WbSkeleton className={classes.buttonSkeleton} />
                <WbSkeleton className={classes.buttonSkeleton} />
                <WbSkeleton className={classes.buttonSkeleton} />
                <WbSkeleton className={classes.buttonSkeleton} />
            </div>
        </WbGrid>
    );
}
